<template>
  <div>
    Veuillez télécharger
    <a
      target="_blank"
      :href="$storeDemandeBourse.DonneesFormulaire.ResumeCandidature"
      >ce document</a
    >
    afin de le signer et le légaliser par le candidat et les parents ou le tuteur (cas échéant)  puis de le déposer dans la rubrique suivante : <br />
    <upload-btn
      class="mr-10"
      color="secondary"
      :loading="uploadFileLoading"
      :selectedFileName="
        this.$storeDemandeBourse.DonneesFormulaire.PublipostageSigne.NomFichier
      "
      defaultButtonText="Sélectionner votre document"
      ref="btnupload"
      @file-update="selectFile"
      :acceptFormats="['pdf']"
    >
    </upload-btn>
    <small>Formats acceptés : pdf</small>
    <br />
    <small>Taille maximum du fichier : 8Mo</small>

    <v-snackbar :timeout="2000" color="error" elevation="24" v-model="snackbar">
      Taille maximale du fichier dépassée.
    </v-snackbar>
  </div>
</template>
<script>
import UploadButton from "@/components/CustomFileUpload";
export default {
  components: {
    "upload-btn": UploadButton,
  },
  data() {
    return {
      $storeDemandeBourse: this.$storeDemandeBourse,
      $storeCatalogue: this.$storeCatalogue,
      uploadFileLoading: false,
      snackbar: false,
    };
  },
  methods: {
    // Fonction appelé quand un fichier sélectionné ou déselectionné dans le 'upload-btn'
    async selectFile(file) {
      this.snackbar = false;
      if (file) {
        if (file.size/1024 > 8000) {
          this.$storeDemandeBourse.DonneesFormulaire.PublipostageSigne.NomFichier =
            "";
          this.$storeDemandeBourse.DonneesFormulaire.PublipostageSigne.DonneePieceJointe =
            null;
          this.snackbar = true;
        } else {
          this.uploadFileLoading = true;
          this.$storeDemandeBourse.DonneesFormulaire.PublipostageSigne.NomFichier =
            file.name;
          await this.readFile(
            file,
            this.$storeDemandeBourse.DonneesFormulaire.PublipostageSigne
          );
          setTimeout(this.stopLoadinMode, 2000);
        }
      } else {
        this.$storeDemandeBourse.DonneesFormulaire.PublipostageSigne.NomFichier =
          "";
        this.$storeDemandeBourse.DonneesFormulaire.PublipostageSigne.DonneePieceJointe =
          null;
      }
    },
    // Lire le contenu d'un fichier la data de l'élément en cours
    readFile(file, monFichier) {
      var reader = new FileReader();

      // Listener de fin de lecture
      reader.onloadend = function () {
        // Recupérer la chaine lise dans le data de l'élément en cours
        monFichier.DonneePieceJointe = btoa(reader.result);
      };

      // Lancer la lecture du ficheir
      reader.readAsBinaryString(file);
    },

    // Arrêter
    stopLoadinMode() {
      this.uploadFileLoading = false;
    },
  },
};
</script>
